import type { HoComponents } from '@pos/api-client';
import { hoApi } from '../api';

export type FormSubmissionItem = HoComponents['schemas']['FormSubmissionListItem'];
export type FormSubmissionDetail = HoComponents['schemas']['FormSubmissionDetail'];

/** The server checks it again (CMS phase 2): the answers are personal data. */
export const SUBMISSIONS_PERMISSION = 'ho.form_submissions.manage';

export const SUBMISSION_STATUSES = ['new', 'handled', 'spam'] as const;
export type SubmissionStatus = (typeof SUBMISSION_STATUSES)[number];

export const STATUS_TAG = { new: 'pending', handled: 'active', spam: 'inactive' } as const satisfies Record<SubmissionStatus, string>;

export const submissionsKey = (status: string, page: number, pageSize: number) => ['ho', 'form-submissions', status, page, pageSize] as const;
export const submissionKey = (id: string) => ['ho', 'form-submission', id] as const;

export async function listSubmissions(status: string, page: number, pageSize: number) {
  const { data, error } = await hoApi.GET('/api/v1/cms/form-submissions', {
    params: { query: { status: status || undefined, page, pageSize } },
  });
  if (!data) throw error;
  return data;
}

export async function getSubmission(id: string): Promise<FormSubmissionDetail> {
  const { data, error } = await hoApi.GET('/api/v1/cms/form-submissions/{id}', { params: { path: { id } } });
  if (!data) throw error;
  return data;
}

export async function updateSubmission(id: string, status: SubmissionStatus, note: string): Promise<FormSubmissionDetail> {
  const { data, error } = await hoApi.PUT('/api/v1/cms/form-submissions/{id}', {
    params: { path: { id } },
    body: { status, note: note.trim() || null },
  });
  if (!data) throw error;
  return data;
}
